import React from 'react';
import {cookiesPolicyUrl, privacyPolicyUrl} from '../../api';
import st from './policy.module.scss';

export const Policy = () => {
  return (
    <>
      I acknowledge that the Blue House Technologies screening process is confidential and that I will not publicly
      disclose details about this process. By submitting, you acknowledge that you have read and agree to our{' '}
      <a className={st.link} href={privacyPolicyUrl} rel='noreferrer' target='_blank'>
        Privacy Policy
      </a>
      , and{' '}
      <a className={st.link} href={cookiesPolicyUrl} rel='noreferrer' target='_blank'>
        Cookie Policy
      </a>
    </>
  );
};
